import { FC, memo } from 'react';
import classNames from 'classnames';
import { Loader } from 'shared/ui';

import cls from './PageLoader.module.scss';
import { Flex } from 'shared/_ui';

interface PageLoaderProps {
    className?: string;
}

export const PageLoader: FC<PageLoaderProps> = memo((props) => {
    const { className } = props;

    return (
        <Flex
            justify="center"
            align="center"
            className={classNames(cls.PageLoader, className)}
        >
            <Loader />
        </Flex>
    );
});
